import PropTypes from "prop-types";
import Swimlane from "../../../components/Swimlane/component";
import { NUM_STORIES_REGION_SWIMLANE } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import ContentArea from "../../../components/ContentArea/async.component";
import { SectionHeading } from "../../../components/Heading/component";
import Slider from "../../../components/Slider/component";
import VideoPlaylist from "../../../components/LayoutFactory/layouts/VideoPlaylist/component";
import { useEffect } from "react";
import { fetchVideoByLineup } from "../../../actions/Video/dispatchers";
import { REGIONS_LIST } from "../../../constants/regions";
import { CAROUSEL_STORIES_MAX_COUNT } from "../../../constants/content";
import { extractDataFromStateBasedOnStorePath } from "../../../utils/store/library";
import RadioBar from "../../../components/RadioBar/component";
/**
 * Return the NewsLanding REGION Template
 *
 * @param {string} path the current app path
 * @param {object} splitProps the props required for the page ContentArea components
 */

const swimlaneProps = {
    headline: "Featured",
    itemCount: NUM_STORIES_REGION_SWIMLANE,
    className: "newsTheme",
    showMoreLink: false,
    hasHeadlineLink: false,
    fetchSection: true,
};

const Region = ({ path, splitProps }) => {
    return (
        <>
            <div className="landingNewsSplit" data-testid="region">
                <ContentArea {...splitProps.featuredProps} />
                <Swimlane {...swimlaneProps} section={`${path}/swimlane`} />
                <SectionHeading text="More CBC News" />
                <ContentArea {...splitProps.moreContentProps} />
            </div>
        </>
    );
};

Region.propTypes = {
    path: PropTypes.string,
    splitProps: PropTypes.object,
};

const RegionVideo = ({ path, splitProps }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchVideoByLineup("apps-video", path));
    }, [path]);
    const playlistData = useSelector((state) =>
        extractDataFromStateBasedOnStorePath(state, "video.curatedPlaylist")
    );
    const { liveRadioRegion, title } = REGIONS_LIST.find(
        (region) => region.path === path
    );

    const playlistLayoutProps = { playlistTitle: "Featured Video" };
    const playlistItems = playlistData?.items
        ? playlistData.items.filter((item) => item)
        : [];
    const featureAttributionData = {
        instance: "News",
    };

    return (
        <div className="landingNewsSplit" data-testid="region">
            <Slider
                title="Featured"
                header={`${title} Video`}
                section={`${path}/video`}
                itemCount={CAROUSEL_STORIES_MAX_COUNT}
            />
            <ContentArea {...splitProps.featuredProps} />
            <RadioBar
                listenLinkCMP="Radio_mobileweb_unit"
                defaultRadioRegion={liveRadioRegion}
            />
            <Swimlane {...swimlaneProps} section={`${path}/swimlane`} />
            <div className="playlistSwimlane">
                <SectionHeading text={`Featured Video`} />
                <VideoPlaylist
                    layout={playlistLayoutProps}
                    items={playlistItems}
                    featureAttributionData={featureAttributionData}
                />
            </div>
            <SectionHeading text="More CBC News" />
            <ContentArea {...splitProps.moreContentProps} />
        </div>
    );
};

RegionVideo.propTypes = Region.propTypes;

export { Region as default, RegionVideo };
